module.exports = __webpack_public_path__ + "static/img/IMG_0877.b78a70d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0877.jpg
// module id = RlsC
// module chunks = 11